/** Cursor page size for Mission Control list tabs (feed, tasks, missions, pipeline, artefacts). */
export const MISSION_CONTROL_PAGE_SIZE = 100;

/** Debounce before toolbar search triggers list API calls (regex / post-filter scans). */
export const MISSION_CONTROL_SEARCH_DEBOUNCE_MS = 1000;

/** Minimum toolbar query length before list search runs (server enforces the same). */
export const MISSION_CONTROL_SEARCH_MIN_CHARS = 4;

/** Max WebSocket / interaction-overlay events kept before fetched pages. */
export const FEED_LIVE_EVENTS_CAP = 200;

/** Single ``listArtifacts`` fetch after interaction completed (feed window). */
export const FEED_ARTIFACT_REFRESH_LIMIT = 20;
